import { argon2id } from 'hash-wasm';
/**
 * Default Argon2id parameters per OWASP 2026 guidance and spec §5.2.
 * Memory: 64 MiB. Iterations: 3. Parallelism: 4.
 *
 * These parameters are a trade-off: high enough to make PIN brute force
 * expensive on modern hardware, low enough that mobile devices can run
 * them in under 500 ms.
 */
export const DEFAULT_KDF_PARAMS = {
    memoryKiB: 65536,
    iterations: 3,
    parallelism: 4,
};
/**
 * Derive a 32-byte encryption key from a PIN using Argon2id.
 * The salt MUST be 16+ random bytes stored alongside the ciphertext.
 * Throws on empty PIN or short salt.
 */
export async function deriveKeyFromPin(pin, salt, params = DEFAULT_KDF_PARAMS) {
    if (pin.length === 0) {
        throw new Error('PIN must not be empty');
    }
    if (salt.length < 16) {
        throw new Error(`Salt must be at least 16 bytes, got ${salt.length}`);
    }
    const hex = await argon2id({
        password: pin,
        salt,
        iterations: params.iterations,
        memorySize: params.memoryKiB,
        parallelism: params.parallelism,
        hashLength: 32,
        outputType: 'hex',
    });
    return hexToBytes(hex);
}
function hexToBytes(hex) {
    const out = new Uint8Array(hex.length / 2);
    for (let i = 0; i < out.length; i++) {
        const byte = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
        out[i] = byte;
    }
    return out;
}
//# sourceMappingURL=kdf.js.map